import { render } from "./ContactHeader.vue?vue&type=template&id=65115c92"
import script from "./ContactHeader.vue?vue&type=script&lang=ts"
export * from "./ContactHeader.vue?vue&type=script&lang=ts"

import "./ContactHeader.vue?vue&type=style&index=0&id=65115c92&lang=scss"
script.render = render

export default script